const style = {
  root: {
    padding: '0px 20px',
  },
}

export default style
